import React, { useState } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import Icon from "ceicons/es/icons/Unit";
import { useTranslation } from "ceco-polyglot";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../../../environment";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";

import "./unitModal.scss";

export default function UnitModal(props) {
  const { trigger, edit = false, refetchData, unit } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const t = useTranslation();

  function handleChange(evt) {
    const { value } = evt.target;
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }

  function createUnit() {
    return new Promise((resolve, reject) => {
      const variables = { ...formData };

      commitMutation(environment, {
        mutation: UnitModalCreateMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  function editUnit() {
    return new Promise((resolve, reject) => {
      const variables = { ...formData };

      commitMutation(environment, {
        mutation: UnitModalUpdateMutation,
        variables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? createUnit : editUnit;
      const msg = !edit ? t("message.added_unit") : t("message.edited_unit");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e.errors[0]?.message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;
    if (!formData.code) {
      errors = { ...errors, code: t("form.errorRequired") };
    }
    if (!formData.description) {
      errors = { ...errors, description: t("form.errorRequired") };
    }
    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  return (
    <BasicModal
      size="mini"
      className="single-button"
      title={
        <div className="modalTitle">
          <Icon />
          {!edit ? t("modalTitle.createUnit") : t("modalTitle.editUnit")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit ? setFormData({ ...unit }) : setFormData({});
        },
      })}
      actions={
        <Button
          type="submit"
          primary
          onClick={() => {
            onSubmit();
          }}
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form onSubmit={onSubmit}>
        {/* <ImageDropzone /> */}
        <Form.Input
          name="code"
          error={formErrors && formErrors["code"]}
          value={formData.code || ""}
          label={t("form.name")}
          placeholder={t("form.name")}
          onChange={handleChange}
          required
        />
        <Form.Input
          name="description"
          error={formErrors && formErrors["description"]}
          value={formData.description || ""}
          label={t("form.description")}
          placeholder={t("form.description")}
          onChange={handleChange}
          required
        />
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}

const UnitModalCreateMutation = graphql`
  mutation UnitModalCreateMutation($code: String!, $description: String!) {
    unitMeasureCreate(input: { code: $code, description: $description }) {
      unitMeasure {
        id
        code
        description
      }
    }
  }
`;
const UnitModalUpdateMutation = graphql`
  mutation UnitModalUpdateMutation(
    $id: ID!
    $code: String
    $description: String
  ) {
    unitMeasureUpdate(
      input: { id: $id, code: $code, description: $description }
    ) {
      unitMeasure {
        id
        code
        description
      }
    }
  }
`;
